const api = {
  // 按照预算科目id搜索下一级预算科目信息的接口
  getBudgetSubject: {
    type: 'post',
    url: '/purchaser/general/budget/subject/list/share/component'
  },
  // 按名称、预算科目外部编码模糊搜索接口
  remoteFilter: {
    type: 'post',
    url: '/purchaser/general/budget/subject/leaf/fuzzy/searchKey/share/component'
  }
}
export default api
